import {
  createPluginFactory,
} from '@udecode/plate';
import { withNoteLayout } from './withNoteLayout';
import { NoteHeaderElement } from './NoteHeaderElement';

export const LAYOUT_NOTE = 'layout-note';
export const NOTE_HEADER = 'note-header';
export const NOTE_HEADER_VOID = 'note-header-void';

export const createNoteLayoutPlugin = createPluginFactory({
  key: LAYOUT_NOTE,
  withOverrides: withNoteLayout,
  plugins: [
    {
      key: NOTE_HEADER,
      isElement: true,
      serializeHtml: NoteHeaderElement,
    },
    {
      key: NOTE_HEADER_VOID,
      isElement: true,
      isVoid: true,
      serializeHtml: NoteHeaderElement,
    },
  ],
});
